import { createReducer, on } from '@ngrx/store';
import * as inviteUserSubmitAction from '../actions/submit-InviteUser.action';
import { inviteUserSubmitState } from '../invite-user.state';

const initialState: inviteUserSubmitState = {
  submitResponse: null,
  errorMessage: null,
  relaventError: false,
  loading: false,
  success: null,
  error: null,
};

export const InviteUserInternalReducer = createReducer(
  initialState,
  on(
    inviteUserSubmitAction.submitInviteUserResponce,
    (state: inviteUserSubmitState, { submitResponse }) => ({
      ...state,
      submitResponse,
      errorMessage: submitResponse,
    })
  ),
  on(
    inviteUserSubmitAction.submitInviteUserAction,
    (state: inviteUserSubmitState) => ({
      ...state,
      loading: true,
      success: null,
      error: null,
    })
  ),
  on(
    inviteUserSubmitAction.clearSubmitFlag,
    (state: inviteUserSubmitState) => ({
      ...state,
      submitResponse: null,
      loading: false,
      success: null,
      error: null,
    })
  ),
  on(
    inviteUserSubmitAction.updateErrorStatus,
    (state: inviteUserSubmitState, { errorStatus }) => ({
      ...state,
      relaventError: errorStatus,
    })
  )
);
